import { html } from 'lit';
const Tomorrow =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.42 3.205a.68.68 0 0 1 .68.68v.68h5.888v-.68a.68.68 0 1 1 1.358 0v.68h2.039a2.49 2.49 0 0 1 2.491 2.49v5.435a.68.68 0 0 1-1.359 0V10H4.57v7.926c0 .626.507 1.133 1.132 1.133h5.888a.68.68 0 1 1 0 1.359H5.702a2.49 2.49 0 0 1-2.491-2.492V7.055a2.49 2.49 0 0 1 2.491-2.49H7.74v-.68a.68.68 0 0 1 .68-.68m6.568 2.718v.68a.68.68 0 1 0 1.358 0v-.68h2.039c.625 0 1.132.507 1.132 1.132v1.586H4.57V7.055c0-.625.507-1.132 1.132-1.132H7.74v.68a.68.68 0 1 0 1.36 0v-.68zm3.641 10.672a.68.68 0 1 1 .961-.96l1.922 1.92a.68.68 0 0 1 0 .962l-1.922 1.922a.68.68 0 0 1-.96-.961l1.44-1.442zm-4.238-.96a.68.68 0 0 0 0 .96l1.44 1.441-1.44 1.442a.68.68 0 0 0 .96.96l1.922-1.921a.68.68 0 0 0 0-.961l-1.921-1.922a.68.68 0 0 0-.961 0" clip-rule="evenodd"/>
  </svg>
`;
export default Tomorrow;
